import * as RadixAspectRatio from '@radix-ui/react-aspect-ratio';
import { forwardRef, ImgHTMLAttributes, Ref } from 'react';
import styled from 'styled-components';

type AspectRatioProps = RadixAspectRatio.AspectRatioProps;

type AspectRatioImgProps = {
	src: string;
	alt?: string;
} & ImgHTMLAttributes<HTMLImageElement>;

const StyledImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

function CellulaAspectRatio({ children, ...rest }: AspectRatioProps, ref: Ref<HTMLDivElement>): JSX.Element {
	return (
		<RadixAspectRatio.Root {...rest} ref={ref}>
			{children}
		</RadixAspectRatio.Root>
	);
}

function CellulaAspectRatioImg(props: AspectRatioImgProps, ref: Ref<HTMLImageElement>): JSX.Element {
	return <StyledImg {...props} ref={ref} />;
}

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

/**
 * A component to render an image with a given aspect ratio.
 */
export const AspectRatio = {
	Root: forwardRef(CellulaAspectRatio),
	Img: forwardRef(CellulaAspectRatioImg),
} as const;
export type { AspectRatioProps };
